import React from 'react';
import PropTypes from 'prop-types';
import apple from 'assets/images/app_store.png';
import google from 'assets/images/google_play.png';
import { googleStore, appleStore } from 'settings';

const StoreButtons = (props) => {
  const { title } = props;
  return (
    <React.Fragment>
      {title && <h3>Get the app on your mobile device</h3>}
      <div className="storeButtons__container">
        <a href={appleStore} target="_blank" rel="noopener noreferrer"><img src={apple} alt="App store" /></a>
        <a href={googleStore} target="_blank" rel="noopener noreferrer"><img src={google} alt="Google Play" /></a>
      </div>
    </React.Fragment>
  );
};

export default StoreButtons;

StoreButtons.propTypes = {
  title: PropTypes.bool,
};

StoreButtons.defaultProps = {
  title: false,
};
